import { useEffect } from 'react';
import { useBillingRequest } from '../services/apis/billing/useBillingRequest';
import { useAuthStore } from '../stores/auth/useAuthStore';

interface PaymentVerificationHandlerProps {
  onVerificationStatusChange: (needed: boolean, verificationData?: any) => void;
}

const PaymentVerificationHandler: React.FC<PaymentVerificationHandlerProps> = ({ 
  onVerificationStatusChange 
}) => {
  const { store: { user, subscription } } = useAuthStore();
  const { getPaymentVerificationStatusRequestHandler } = useBillingRequest();

  useEffect(() => {
    const checkVerificationStatus = async () => {
      if (!user || !subscription) return;

      try {
        const response = await getPaymentVerificationStatusRequestHandler();
        
        if (response?.paymentVerificationRequired) {
          onVerificationStatusChange(true, response);
        } else {
          onVerificationStatusChange(false);
        }
      } catch (error) {
        onVerificationStatusChange(false);
      }
    };

    checkVerificationStatus();
  }, [user, subscription]);

  return null;
};

export default PaymentVerificationHandler;

